import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

import { logging } from './logging.module'
import { alert } from './alert.module'
import { version } from './version.module'
import { pricing } from './pricing.module'
import { account } from './account.module'
import { captive } from './captive.module'
import { plan } from './plan.module'
import { event } from './event.module'
import { nav } from './nav.module'

Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
  }

const mutations= {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
}
  
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    logging,
    alert,
    account,
    captive,
    version,
    pricing,
    plan,
    event,
    nav
  },
  state,
  mutations: {
    ...mutations,
    resetStore(state, type){
      
      Object.keys(this._modules.root._children).forEach(moduleName => {
        if ( this._mutations[`${moduleName}/reset`]) {
          this.commit(`${moduleName}/reset`, type)
        }
      })
    }
  }
})
  
export default store  


